module.exports =
  '_PRIVACY_POLICY':
    'TITLE': '個人情報保護ポリシー'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/policy/i18n/ja.coffee